<template>
  <div>
      <start-assessment v-if="action === 'start'"></start-assessment>
      <update-assessment v-if="action === 'update'"></update-assessment>
      <create-assessment v-if="action === 'create'"></create-assessment>
      <completed-assessment v-if="action === 'completed'"></completed-assessment>
  </div>
</template>

<script>
import StartAssessment from '@/components/StartAssessment';
import CreateAssessment from '@/components/CreateAssessment';
import UpdateAssessment from '@/components/UpdateAssessment';
import CompletedAssessment from '@/components/CompletedAssessment';
export default {
    name: 'Assessment',
    components: {
        'start-assessment': StartAssessment,
        'create-assessment': CreateAssessment,
        'update-assessment': UpdateAssessment,
        'completed-assessment': CompletedAssessment
    },
    computed: {
        action() {
            return this.$route.name.split('.')[1];
        }
    }
}
</script>

<style>

</style>